module.exports = __webpack_public_path__ + "static/media/reports_active.021db4c9.svg";